import PropTypes from 'prop-types';
import React, {useState} from "react";
import confirmCss from "./ConfirmDialog.scss";
import css from "./ErrorModal.scss";
import classnames from 'classnames';
import ConfirmDialog from "./ConfirmDialog";

const ErrorModal = props => {
    const [isOpen, setIsOpen] = useState(true);
    return(
        <ConfirmDialog confirmText={props.confirmText}
                       descriptionText={props.message}
                       headerText=""
                       isOpen={isOpen}
                       overlayClassName={classnames(confirmCss.overlay, css.overlay)}
                       onConfirm={() => {
                           setIsOpen(false);
                           props.onClose()
                       }} />
    );
};

ErrorModal.defaultProps = {
    confirmText: 'OK'
};

ErrorModal.propTypes = {
    confirmText: PropTypes.string,
    message: PropTypes.string.isRequired,
    onClose: PropTypes.func.isRequired
};

export default ErrorModal;
